/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DatabaseField } from './DatabaseField';
import {
    DatabaseFieldFromJSON,
    DatabaseFieldFromJSONTyped,
    DatabaseFieldToJSON,
} from './DatabaseField';
import type { DatabaseFieldPreviewOptions } from './DatabaseFieldPreviewOptions';
import {
    DatabaseFieldPreviewOptionsFromJSON,
    DatabaseFieldPreviewOptionsFromJSONTyped,
    DatabaseFieldPreviewOptionsToJSON,
} from './DatabaseFieldPreviewOptions';
import type { DatabaseFieldVisibilityRule } from './DatabaseFieldVisibilityRule';
import {
    DatabaseFieldVisibilityRuleFromJSON,
    DatabaseFieldVisibilityRuleFromJSONTyped,
    DatabaseFieldVisibilityRuleToJSON,
} from './DatabaseFieldVisibilityRule';
import type { DatabasePeriodFieldLook } from './DatabasePeriodFieldLook';
import {
    DatabasePeriodFieldLookFromJSON,
    DatabasePeriodFieldLookFromJSONTyped,
    DatabasePeriodFieldLookToJSON,
} from './DatabasePeriodFieldLook';

/**
 * 
 * @export
 * @interface DatabasePeriodField
 */
export interface DatabasePeriodField extends DatabaseField {
    /**
     * 
     * @type {DatabasePeriodFieldLook}
     * @memberof DatabasePeriodField
     */
    type?: DatabasePeriodFieldLook;
    /**
     * 
     * @type {boolean}
     * @memberof DatabasePeriodField
     */
    withSeconds?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    suffixStart?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    suffixEnd?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    defaultStartValue?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    defaultEndValue?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    defaultStartTimeValue?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    defaultEndTimeValue?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    defaultValueType?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    defaultStartType?: string;
    /**
     * 
     * @type {string}
     * @memberof DatabasePeriodField
     */
    defaultEndType?: string;
    /**
     * 
     * @type {number}
     * @memberof DatabasePeriodField
     */
    defaultStartRange?: number;
    /**
     * 
     * @type {number}
     * @memberof DatabasePeriodField
     */
    defaultEndRange?: number;
}

/**
 * Check if a given object implements the DatabasePeriodField interface.
 */
export function instanceOfDatabasePeriodField(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DatabasePeriodFieldFromJSON(json: any): DatabasePeriodField {
    return DatabasePeriodFieldFromJSONTyped(json, false);
}

export function DatabasePeriodFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatabasePeriodField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        ...DatabaseFieldFromJSONTyped(json, ignoreDiscriminator),
        'type': !exists(json, 'type') ? undefined : DatabasePeriodFieldLookFromJSON(json['type']),
        'withSeconds': !exists(json, 'withSeconds') ? undefined : json['withSeconds'],
        'suffixStart': !exists(json, 'suffixStart') ? undefined : json['suffixStart'],
        'suffixEnd': !exists(json, 'suffixEnd') ? undefined : json['suffixEnd'],
        'defaultStartValue': !exists(json, 'defaultStartValue') ? undefined : json['defaultStartValue'],
        'defaultEndValue': !exists(json, 'defaultEndValue') ? undefined : json['defaultEndValue'],
        'defaultStartTimeValue': !exists(json, 'defaultStartTimeValue') ? undefined : json['defaultStartTimeValue'],
        'defaultEndTimeValue': !exists(json, 'defaultEndTimeValue') ? undefined : json['defaultEndTimeValue'],
        'defaultValueType': !exists(json, 'defaultValueType') ? undefined : json['defaultValueType'],
        'defaultStartType': !exists(json, 'defaultStartType') ? undefined : json['defaultStartType'],
        'defaultEndType': !exists(json, 'defaultEndType') ? undefined : json['defaultEndType'],
        'defaultStartRange': !exists(json, 'defaultStartRange') ? undefined : json['defaultStartRange'],
        'defaultEndRange': !exists(json, 'defaultEndRange') ? undefined : json['defaultEndRange'],
    };
}

export function DatabasePeriodFieldToJSON(value?: DatabasePeriodField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ...DatabaseFieldToJSON(value),
        'type': DatabasePeriodFieldLookToJSON(value.type),
        'withSeconds': value.withSeconds,
        'suffixStart': value.suffixStart,
        'suffixEnd': value.suffixEnd,
        'defaultStartValue': value.defaultStartValue,
        'defaultEndValue': value.defaultEndValue,
        'defaultStartTimeValue': value.defaultStartTimeValue,
        'defaultEndTimeValue': value.defaultEndTimeValue,
        'defaultValueType': value.defaultValueType,
        'defaultStartType': value.defaultStartType,
        'defaultEndType': value.defaultEndType,
        'defaultStartRange': value.defaultStartRange,
        'defaultEndRange': value.defaultEndRange,
    };
}

